@if (attribute) {
<div class="flex flex-middle flex-justify-between m-t-2 p-t-2 p-b-2 p-b-3-s b-t"
     [class.wrap]="wishlist">
    <div class="flex-grow flex">
        <p class="p2">{{'Select Size:' | translate}}</p>
        <ng-template [productStatus]="$any(selectedOption?.product)"
                     let-status="status">
            @if (selectedOption.product) {
            <div class="flex">
                @if (!status.isSalable) {
                <div class="p2 col-2 p-l-1 uppercase">{{'Out of stock' | translate}}</div>
                }
                @if (status.isLowQty) {
                <div class="p2 p-l-1">{{'Only % remaining' | translate : status.maxQty}}</div>
                }
            </div>
            }
        </ng-template>
    </div>
    @if (!!sizeGuideVariant) {
    <button class="m-r-1 b-b b-col-1 c1"
            type="button"
            (click)="sizeGuideClickHolder(sizeGuideVariant)">
        {{'Size guide' | translate}}
    </button>
    }
</div>

<div class="p-b"
     [ngClass]="!wishlist ? 'b-t-1-s' : 'p-b-8-s'"
     [class.wrap]="wishlist"
     [grid]="[4, 4, attribute?.options.length <= 3 ? 3 : 7, attribute?.options.length <= 3 ? 3 : 7][app.client.sizeId]"
     [gridColumnGap]="[8,8,2,2][app.client.sizeId]"
     [gridRowGap]="[4,4,2,2][app.client.sizeId]">
    <!-- attribute options -->
    @for (option of attribute.options; track option.value) {
    <label class="w-12 no-wrap p-t-1 p-t-2-m p-t-2-s p-r-1 p-r-0-s p-b-1 p-b-2-m p-b-2-s p-l-1 p-l-0-s b-a b-radius-max fs-4 lh-1 center pe-auto-s cursor-pointer _option"
           [class.is-picked]="isPicked(attribute, option)"
           [class.is-disabled]="!option.salable"
           (click)="pick(attribute, option)">{{option.label}}</label>
    }
</div>
}